import type { ClientOptions, RpcClient } from "@redotech/rpc/client";
import { createRpcClient } from "@redotech/rpc/client";
import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { rpcDefinition } from "./definition";

export type RedoInventoryRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;

export function createRedoInventoryRpcClient(
  options: ClientOptions<typeof rpcDefinition>,
): RpcClient<RedoInventoryRpcDefinition> {
  return createRpcClient(rpcDefinition, options);
}

export type RedoInventoryRpcClient = ReturnType<
  typeof createRedoInventoryRpcClient
>;
